export default {
  extratimepolicyname: {
    header: 'Extra time policy Name & Description',
    headercss: 'vmHeader',
    subheader: 'Extra Time name',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  description: {
    header: '',
    headercss: 'vmHeader',
    subheader: 'Internal description for other admins who would view this setting',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  extratime: [{
    isworkingbenefit: {
      header: 'Working Day Benefits',
      headercss: 'vmHeader',
      subheader: 'Would you like to keep track of extra time of employees on working days?',
      subheadercss: 'vmSubHeader',
      values: '<val>',
    },
    benefittypeid: [{
      1: {
        header: '',
        headercss: 'vmHeader',
        subheader: 'How do employees receive benefits for working extra time on a working day',
        subheadercss: 'vmSubHeader',
        values: 'Employees are paid for extra time',
      },
      2: {
        header: '',
        headercss: 'vmHeader',
        subheader: 'How do employees receive benefits for working extra time on a working day',
        subheadercss: 'vmSubHeader',
        values: 'Employees earn comp-off leaves for extra time',
      },
    },
    ],
    maxearninghour: {
      header: '',
      headercss: 'vmHeader',
      subheader: '',
      subheadercss: 'vmSubHeader',
      values: 'Limit the number of payable extra time hours earned in one day to <val>',
    },
    requiredhour: {
      header: '',
      headercss: 'vmHeader',
      subheader: '',
      subheadercss: 'vmSubHeader',
      values: 'Applicable only if employee complete minimum <val> hours.',
    },
    creditcompoff: {
      header: '',
      headercss: 'vmHeader',
      subheader: 'Employees earn comp-off leaves for each hour of extra time',
      subheadercss: 'vmSubHeader',
      values: 'Employees receive <val> credit(s) for each hour of extra time',
    },
    maxearningcompoff: {
      header: '',
      headercss: 'vmHeader',
      subheader: '',
      subheadercss: 'vmSubHeader',
      values: 'Limit the number of comp-off leaves earned in one day to <val>',
    },
    accumulationmonths: {
      header: '',
      headercss: 'vmHeader',
      subheader: '',
      subheadercss: 'vmSubHeader',
      values: 'Hours can be accumulated over <val> month(s)',
    },
    isconsiderbuffertime: {
      header: 'Do you want to set buffer between working hours and start of extra time?',
      headercss: 'vmHeader',
      subheader: 'Consider work done in buffer period for extra time calculation',
      subheadercss: 'vmSubHeader',
      values: '<val>',
    },

    buffertime: {
      header: '',
      headercss: 'vmHeader',
      subheader: '',
      subheadercss: 'vmSubHeader',
      values: 'The buffer between work duration and extra time is <val> mins.',
    },
  },
  {
    isworkingbenefit: {
      header: 'Non-Working Day Benefits',
      headercss: 'vmHeader',
      subheader: 'Would you like to keep track of extra time of employees on Non-working days?',
      subheadercss: 'vmSubHeader',
      values: '<val>',
    },
    benefittypeid: [{
      1: {
        header: '',
        headercss: 'vmHeader',
        subheader: 'How do employees receive benefits for working extra time on a Non-working days?',
        subheadercss: 'vmSubHeader',
        values: 'Employees are paid for extra time',
      },
      2: {
        header: '',
        headercss: 'vmHeader',
        subheader: 'How do employees receive benefits for working extra time on a working day',
        subheadercss: 'vmSubHeader',
        values: 'Employees earn comp-off leaves for extra time',
      },
    },
    ],
    maxearninghour: {
      header: '',
      headercss: 'vmHeader',
      subheader: '',
      subheadercss: 'vmSubHeader',
      values: 'Limit the number of payable extra time hours earned in one day to <val>',
    },
    requiredhour: {
      header: '',
      headercss: 'vmHeader',
      subheader: '',
      subheadercss: 'vmSubHeader',
      values: 'Applicable only if employee complete minimum <val> hours.',
    },
    creditcompoff: {
      header: '',
      headercss: 'vmHeader',
      subheader: 'Employees earn comp-off leaves for each hour of extra time',
      subheadercss: 'vmSubHeader',
      values: 'Employees receive <val> credit(s) for each hour of extra time',
    },
    maxearningcompoff: {
      header: '',
      headercss: 'vmHeader',
      subheader: '',
      subheadercss: 'vmSubHeader',
      values: 'Limit the number of comp-off leaves earned in one day to <val>',
    },
    accumulationmonths: {
      header: '',
      headercss: 'vmHeader',
      subheader: '',
      subheadercss: 'vmSubHeader',
      values: 'Hours can be accumulated over <val> month(s)',
    },
  },
  ],
  isetapprovalrequired: {
    header: 'Extra Time Policy',
    headercss: 'vmHeader',
    subheader: 'Do you want employees to work extra time only on approval? (Employee will not receive extra time benefits if prior approval to work extra time is not taken).',
    subheadercss: 'vmSubHeader',
    values: '<val>, employees need to take prior approval',
  },
  ispastdateallowed: {
    header: '',
    headercss: 'vmHeader',
    subheader: 'Allow employees to get past dated extra time approval',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  extratimecompoffpolicy: [
    {

      isseparatebalance: {
        header: '',
        headercss: 'vmHeader',
        subheader: 'Do you want to maintain two separate balance for comp-off leaves earned on working and non-working days?',
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      ispayableapproverequired: {
        header: '',
        headercss: 'vmHeader',
        subheader: 'Does crediting payable earning require special permissions?',
        subheadercss: 'vmSubHeader',
        values: '<val>, Follow extra time approval workflow (approvers will only receive one request per day of extra time)',
      },
      iscompoffapproverequired: {
        header: '',
        headercss: 'vmHeader',
        subheader: 'Does crediting comp-off leaves require approval?',
        subheadercss: 'vmSubHeader',
        values: '<val>, Follow attendance approval workflow (approvers will only receive one request per day of extra time)',
      },
      lapsetypeid: [{
        1: {
          header: '',
          headercss: 'vmHeader',
          subheader: 'How do we handle unused comp-off balance?',
          subheadercss: 'vmSubHeader',
          values: 'Lapse days after earning the comp-off',
        },
        2: {
          header: '',
          headercss: 'vmHeader',
          subheader: 'How do we handle unused comp-off balance?',
          subheadercss: 'vmSubHeader',
          values: 'Does not lapse, retain all unused comp-off credit for future use',
        },
        3: {
          header: '',
          headercss: 'vmHeader',
          subheader: 'How do we handle unused comp-off balance?',
          subheadercss: 'vmSubHeader',
          values: 'Lapse at the end of Leave Cycle',
        },

      }],
      lapsedays: {
        header: '',
        headercss: 'vmHeader',
        subheader: '',
        subheadercss: 'vmSubHeader',
        values: 'Lapse <val> days',
      },
      isattachment: {
        header: '',
        headercss: 'vmHeader',
        subheader: 'Do you want to keep attachments (supporting documents) compulsory when applying the earned comp-off leaves?',
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      attachmentdurationlimit: {
        header: '',
        headercss: 'vmHeader',
        subheader: '',
        subheadercss: 'vmSubHeader',
        values: 'Only if leave duration is greater than <val> days.',
      },
      attachmentnote: {
        header: '',
        headercss: 'vmHeader',
        subheader: 'feel free to add description text here for any special instructions regarding attachments required?',
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      maxleave: {
        header: '',
        headercss: 'vmHeader',
        subheader: 'Comp-off leave usage limits',
        subheadercss: 'vmSubHeader',
        values: 'Allow only a maximum of <val> days leave',
      },
      maxdurationtypeid: [{
        1: {
          header: '',
          headercss: 'vmHeader',
          subheader: 'Duration Type for maximum leave allowed',
          subheadercss: 'vmSubHeader',
          values: 'Monthly',
        },
        2: {
          header: '',
          headercss: 'vmHeader',
          subheader: 'Duration Type for maximum leave allowed',
          subheadercss: 'vmSubHeader',
          values: 'Quarterly',
        },
        3: {
          header: '',
          headercss: 'vmHeader',
          subheader: 'Duration Type for maximum leave allowed',
          subheadercss: 'vmSubHeader',
          values: 'Half-yearly',
        },
        4: {
          header: '',
          headercss: 'vmHeader',
          subheader: 'Duration Type for maximum leave allowed',
          subheadercss: 'vmSubHeader',
          values: 'Yearly',
        },
      },
      ],
      consecutiveleave: {
        header: '',
        headercss: 'vmHeader',
        subheader: '',
        subheadercss: 'vmSubHeader',
        values: 'Allow only a maximum consecutive <val> days leave',
      },
      consecutivedurationtypeid: [{
        1: {
          header: '',
          headercss: 'vmHeader',
          subheader: 'Duration Type for maximum consecutive leave allowed',
          subheadercss: 'vmSubHeader',
          values: 'Monthly',
        },
        2: {
          header: '',
          headercss: 'vmHeader',
          subheader: 'Duration Type for maximum leave allowed',
          subheadercss: 'vmSubHeader',
          values: 'Quarterly',
        },
        3: {
          header: '',
          headercss: 'vmHeader',
          subheader: 'Duration Type for maximum leave allowed',
          subheadercss: 'vmSubHeader',
          values: 'Half-yearly',
        },
        4: {
          header: '',
          headercss: 'vmHeader',
          subheader: 'Duration Type for maximum leave allowed',
          subheadercss: 'vmSubHeader',
          values: 'Yearly',
        },
      },
      ],
      allowedhalfday: {
        header: '',
        headercss: 'vmHeader',
        subheader: 'Would you like to allow half-day leave applications using comp-off leaves?',
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      applicationmadeid: [{
        1: {
          header: 'Please choose whether leave applications must be made in advance, or can be applied for dates in the past?',
          headercss: 'vmHeader',
          subheader: '',
          subheadercss: 'vmSubHeader',
          values: 'Applications must be made in advance',
        },
        2: {
          header: 'Please choose whether leave applications must be made in advance, or can be applied for dates in the past?',
          headercss: 'vmHeader',
          subheader: '',
          subheadercss: 'vmSubHeader',
          values: 'Allow leave applications for past dates',
        },
      },
      ],
      mindays: {
        header: '',
        headercss: 'vmHeader',
        subheader: '',
        subheadercss: 'vmSubHeader',
        values: 'Applications must be made at least <val> days in advance',
      },
      mindayduration: {
        header: '',
        headercss: 'vmHeader',
        subheader: '',
        subheadercss: 'vmSubHeader',
        values: 'Applications is required only if leave duration is more than <val> days',
      },
      maxdays: {
        header: '',
        headercss: 'vmHeader',
        subheader: '',
        subheadercss: 'vmSubHeader',
        values: 'Applications must be made in advance, but not more than <val> days in advance.',
      },
      maxdayduration: {
        header: '',
        headercss: 'vmHeader',
        subheader: '',
        subheadercss: 'vmSubHeader',
        values: 'As long as leave duration is less than <val> days',
      },
      pastdays: {
        header: '',
        headercss: 'vmHeader',
        subheader: '',
        subheadercss: 'vmSubHeader',
        values: 'Allow leave applications for past dates, up to <val> days in the past',
      },
      pastdayduration: {
        header: '',
        headercss: 'vmHeader',
        subheader: '',
        subheadercss: 'vmSubHeader',
        values: 'Allow leave applications for past datesm, only if leave duration is less than <val> days',
      },
    },
  ],
};
